import "./Slider.html";
import "./Slider.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { SliderComponentController } from "./SliderComponentController";

export class SliderComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            inputId: "@?",
            largeStep: "<?",
            max: "<?",
            min: "<?",
            ngModel: "=",
            recalculate: "=?",
            smallStep: "<?",
            tooltip: "<?",
            disabled: "<?",
        };
        this.controller = SliderComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Slider/Slider.html";
    }
}
